<template>
    <div>
        <div class="users-menu">
            <div class="users-filter">
                <input type="text" v-model="userFilter" name="users-filter" id="users-filter" class="form-control" placeholder="Meklētājs">
                <div class="clear-filter" @click="clearFilter()"><i class="material-icons">close</i></div>
            </div>
            <div class="users-new" v-if="userpermissions.includes('users.managment') || 1==1">
                <button class="btn btn-primary"  data-toggle="modal" data-target="#modalnew" ><i class="fas fa-plus"></i> Jauns lietotājs</button>
            </div>

        </div>

        <div class="users">
            <table class="table table-responsive-xl table-hover">
                <thead class="bg-light">
                    <tr class="user-header">
                        <th class="profile">&nbsp;</th>
                        <th class="name">Vārds</th>
                        <th class="position">Amats</th>
                        <th class="email">E-pasts</th>
                        <th class="phone">Tālrunis</th>
                        <th class="roles">Lomas</th>
                        <th class="actions">Darbības</th>
                    </tr>
                </thead>
                <tbody >


                <user-component v-for="user in filteredUsers" :user="user" :roles="roles" :permissions="permissions" :groups="groups" :key="user.id"></user-component>
                </tbody>
            </table>
        </div>

        <div class="modal fade" tabindex="-1"  id="modalnew" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauns lietotājs</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="firstname">Vārds</label>
                                    <input v-on:keyup.enter="newUser" id="firstname" type="text" v-model="firstname" class="form-control" :class="{'is-invalid':errors && ( 'firstname' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.firstname">{{errors.firstname[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="lastname">Uzvārds</label>
                                    <input v-on:keyup.enter="newUser" id="lastname" type="text" v-model="lastname" class="form-control" :class="{'is-invalid':errors && ( 'lastname' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.lastname">{{errors.lastname[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="email">E-pasts</label>
                                    <input v-on:keyup.enter="newUser" id="email" type="text" v-model="email" class="form-control" :class="{'is-invalid':errors && ( 'email' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.email">{{errors.email[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="phone">Tālrunis</label>
                                    <input v-on:keyup.enter="newUser" id="phone" type="text" v-model="phone" class="form-control" :class="{'is-invalid':errors && ( 'phone' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.phone">{{errors.phone[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="position">Amats</label>
                                    <input v-on:keyup.enter="newUser" id="position" type="text" v-model="position" class="form-control" :class="{'is-invalid':errors && ( 'position' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.position">{{errors.position[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="password">Parole</label>
                                    <input id="password" type="text" class="form-control" disabled>
                                    <small class="text-muted">Paroli lietotājs varēs izveidot uzsākot reģistrēšanos.</small>
                                </div>
                                <div class="form-group">
                                    <label for="pin">PIN kods</label>
                                    <input id="pin" type="text" class="form-control" disabled>
                                    <small class="text-muted">PIN kodu lietotājs varēs izveidot uzsākot rēgistrēšanos.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <input type="submit" class="btn btn-primary" value="Pievienot" @click="newUser()" v-if="loading == false">
                        <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
    export default {
        props:['users','roles','permissions','userpermissions','groups'],
        data()
        {
            return {
                loading:false,
                firstname:"",
                lastname:"",
                email:"",
                phone:"",
                position:"",
                errors:null,
                allusers:[],
                userFilter:""
            }
        },
        computed:
        {
          filteredUsers:function()
          {
              var that = this;
              var filterString = this.userFilter.toLowerCase();
              return this.allusers.filter(function(s) {
                if (s.firstname.toLowerCase().includes(filterString) ||
                    s.lastname.toLowerCase().includes(filterString) ||
                    s.position.toLowerCase().includes(filterString) ||
                    s.email.toLowerCase().includes(filterString) ||
                    s.phone.toLowerCase().includes(filterString) ||
                    filterString == ""
                    )
                {
                    return true;
                }
              });


          }
        },
        mounted()
        {
            this.allusers = this.$props.users;
            var that = this;
             EventBus.$on('user_created', () =>{
                that.loading = true;
                that.getUsers();
            });
             EventBus.$on('user_updated', () =>{
                that.loading = true;
                that.getUsers();
            });

        },

        methods: {
            clearFilter()
            {
                this.userFilter = ""
            },
            getUsers()
            {
                var that = this;
                axios.post('/dashboard/api/getUsers').then(response =>
                {
                    that.allusers = response.data.users;
                    that.loading = false;
                });



            },
            newUser()
            {
                var that = this;
                that.loading = true;
                axios.post('/dashboard/api/users',{
                    firstname: this.firstname,
                    lastname: this.lastname,
                    phone: this.phone,
                    email:this.email,
                    position:this.position,
                }).then(response => {
                    if (response.data.status == 'ok')
                    {
                         EventBus.$emit('user_created');
                        that.$toast.open(response.data.message);
                        $(that.$refs.vuemodal).modal('hide');
                    }

                    if (response.data.status == 'error')
                    {
                        that.errors = response.data.errors;
                    }
                    that.loading = false;
                })
            }
        }
    }

</script>

<style lang="scss" scoped>
    .users-menu{
        display:flex;
        align-items: top;
        margin-bottom:20px;
        width:100%;
        .users-new{
            margin-left:auto;
            width:150px;
            flex-shrink:0;
            text-align:right;
        }
        .users-filter
        {
            width:500px;
            max-width:800px;
            flex-grow:1;
            position:relative;
            .clear-filter{
                position:absolute;
                top:0px;
                right:0px;
                padding:7px;
                cursor: pointer;
            }
        }

    }
/*.users{*/
/*    overflow:auto;*/
/*    .user-header-wrapper{*/
/*        display:inline-block;*/
/*        border-bottom:solid 3px #ccc;*/
/*        min-width:100%;*/
/*        &:hover{*/
/*            background-color:#eee;*/
/*        }*/
/*    }*/
/*    .user-header{*/
/*        display:flex;*/
/*        padding:10px;*/
/*        border-bottom:solid 1px #eee;*/
/*        align-items: center;*/
/*        transition:all .2s ease-in-out;*/
/*        background:#eee;*/
/*        font-weight:bold;*/
/*        .profile{*/
/*            width:60px;*/
/*            flex-shrink:0;*/
/*        }*/
/*        .name{*/
/*            min-width:150px;*/
/*            width:15%;*/
/*            padding:0 10px;*/
/*            flex-shrink:0;*/
/*        }*/
/*        .position{*/
/*            min-width:200px;*/
/*            width:15%;*/
/*            padding:0 10px;*/
/*            flex-shrink:0;*/
/*        }*/
/*        .email{*/
/*            min-width:200px;*/
/*            width:15%;*/
/*            padding:0 10px;*/
/*            flex-shrink:0;*/
/*        }*/
/*        .phone{*/
/*             min-width:150px;*/
/*             width:15%;*/
/*             padding:0 10px;*/
/*             flex-shrink:0;*/
/*         }*/
/*        .roles{*/
/*            min-width:150px;*/
/*            width:15%;*/
/*            padding:0 10px;*/
/*            flex-shrink:0;*/
/*        }*/
/*        .actions{*/
/*            margin-left:auto;*/
/*            min-width:100px;*/
/*            width:15%;*/
/*            padding:0 10px;*/
/*            flex-shrink:1;*/
/*            text-align: center;*/
/*        }*/
/*    }*/

/*}*/
</style>

